<template>
  <q-page id="recoger-firma">
    <Firma class=""/>
    

    
  </q-page>
</template>

<script>
import Firma from '@/components/Firma.vue'

export default {
  components: {
    Firma
  },
  data: () => {
    return {
      alert: false,
    }
  }
}
</script>

<style lang="scss">
#recoger-firma {
  display:flex;
  // background-color: lightpink;
}
</style>